module.exports = __webpack_public_path__ + "static/img/zhubaoshoushi.9b76247.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zhubaoshoushi.png
// module id = ybwf
// module chunks = 0